<template>
  <div class="content album-list-page album-studio">

    <!-- ── Page header ─────────────────────────────────────────────────────── -->
    <div class="page-header-card">
      <div class="album-heading">
        <div class="album-heading__icon"><i class="el-icon-picture-outline" aria-hidden="true" /></div>
        <div>
          <span class="album-heading__eyebrow">THƯ VIỆN ẢNH</span>
        <h2 class="page-title">Album ảnh</h2>
        <p class="page-description">Tìm kiếm, duyệt và quản lý toàn bộ album ảnh của trường.</p>
      </div>
      </div>
      <div class="header-badges">
        <div class="summary-badge">
          <span class="summary-badge__label">Tổng số album</span>
          <strong class="summary-badge__value">{{ total || 0 }}</strong>
        </div>
        <div class="summary-badge">
          <span class="summary-badge__label">Đang chọn</span>
          <strong class="summary-badge__value">{{ listIdApproveAlbum.length }}</strong>
        </div>
      </div>
    </div>

    <!-- ── Toolbar ─────────────────────────────────────────────────────────── -->
    <div class="toolbar-card">
      <div class="toolbar-left">
        <span class="toolbar-label"><i class="el-icon-s-operation" aria-hidden="true" />Bộ lọc</span>
        <el-date-picker
            :clearable="true"
            class="toolbar-datepicker"
            value-format="yyyy-MM-dd"
            format="dd-MM-yyyy"
            v-model="dataSearch.dateList"
            type="daterange"
            unlink-panels
            range-separator="→"
            @change="searchByProperties()"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc"
            aria-label="Thời gian tạo album" popper-class="album-studio-popper"
        />

        <el-select
            v-if="getAppTypeUserLogin === 'plus'"
            v-model="dataSearch.albumType"
            @change="handleAlbumTypeChange"
            placeholder="Loại album"
            clearable
            class="toolbar-select"
            aria-label="Lọc theo loại album" popper-class="album-studio-popper"
        >
          <el-option
              v-for="item in albumTypesOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>

        <el-select
            v-if="dataSearch.albumType === 'CLASS'"
            v-model="dataSearch.idClass"
            @change="searchHeaderMethod"
            placeholder="Chọn lớp"
            clearable
            class="toolbar-select"
            aria-label="Lọc theo lớp" popper-class="album-studio-popper"
        >
          <el-option
              v-for="item in listClass"
              :key="item.id"
              :label="item.className"
              :value="item.id"
          />
        </el-select>

        <el-select
            v-if="getAppTypeUserLogin === 'plus'"
            v-model="dataSearch.approved"
            @change="searchHeaderMethod"
            placeholder="Trạng thái"
            clearable
            class="toolbar-select"
            aria-label="Lọc theo trạng thái album" popper-class="album-studio-popper"
        >
          <el-option
              v-for="(item, index) in statusAlbum"
              :key="index"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
      </div>

      <div class="toolbar-right" v-if="checkPermission(['studentQuality_ablum_update'])">
        <router-link :to="{ path: '/album-v2/add' }" class="cancel-link">
          <Phase2ActionButton type="success" icon="el-icon-plus" class="btn-action">
            Tạo Album
          </Phase2ActionButton>
        </router-link>

        <Phase2Dropdown
          label="Tác vụ"
          trigger="click"
          popper-class="album-studio-popper"
          button-type="default"
          button-size=""
          button-icon=""
          :disabled="batchActionLoading"
          :loading="batchActionLoading"
          :items="taskActions"
          @command="handleCommandAction"
        />
      </div>
    </div>

    <!-- ── Album grid ──────────────────────────────────────────────────────── -->
    <div v-if="listLoading" class="album-list-skeleton" role="status" aria-live="polite" aria-label="Đang tải danh sách album">
      <div v-for="number in 6" :key="number" class="album-card-skeleton"><div /><span /><span /></div>
      <span class="album-sr-only">Đang tải danh sách album…</span>
    </div>
    <div v-else-if="listError" class="empty-state" role="alert">
      <i class="el-icon-warning-outline empty-state__icon" />
      <div class="empty-state__title">Không tải được danh sách album</div>
      <div class="empty-state__desc">Vui lòng kiểm tra kết nối và thử lại.</div>
      <el-button icon="el-icon-refresh" @click="searchByProperties">Thử lại</el-button>
    </div>
    <div class="grid-shell" v-else-if="total > 0">
      <!-- Select-all bar -->
      <div class="select-bar">
        <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="isCheckAll"
            @change="handleCheckAllChange"
        >
          Chọn tất cả
        </el-checkbox>
        <span class="select-bar__count" v-if="listIdApproveAlbum.length > 0">
          Đã chọn {{ listIdApproveAlbum.length }} album
        </span>
      </div>

      <div class="album-grid-viewport" role="region" aria-label="Danh sách album" tabindex="0">
      <div class="album-grid">
          <div
              v-for="albumResponse in albumResponseList"
              :key="albumResponse.albumIdx"
              class="album-card"
              :class="{ 'album-card--selected': albumResponse.checkApprove }"
          >
            <!-- Thumbnail -->
            <router-link
                :to="{ path: '/album-v2/detail/' + albumResponse.albumIdx }"
                class="album-card__cover-link"
            >
              <div class="album-card__cover">
                <TagFlag title="Mới" v-if="albumResponse.albumNew || albumResponse.urlPictureFirst === null"/>

                <el-image
                    v-if="albumResponse.urlShowPicture != null && !albumResponse.imageError"
                    class="album-card__img"
                    :src="albumResponse.urlShowPicture"
                    fit="cover"
                    @error="handleAlbumImageError(albumResponse)"
                >
                  <div slot="placeholder" class="album-card__image-loading">
                    <i class="el-icon-loading" />
                  </div>
                </el-image>
                <div v-else-if="albumResponse.imageLoading" class="album-card__no-img">
                  <i class="el-icon-loading album-card__no-img-icon" />
                  <span>Đang tải ảnh</span>
                </div>
                <div v-else class="album-card__no-img">
                  <i class="el-icon-picture-outline album-card__no-img-icon"/>
                  <span>{{ albumResponse.imageError ? 'Không tải được ảnh' : 'Chưa có ảnh' }}</span>
                </div>

                <span class="album-card__cover-count"><i class="el-icon-picture" aria-hidden="true" />{{ albumResponse.pictureNumber }} ảnh</span>

              <!-- Status badge -->
                <div
                    class="album-card__status-badge"
                    :class="albumResponse.albumApproved ? 'badge--visible' : 'badge--hidden'"
                >
                  {{ albumResponse.albumApproved ? 'Đang hiện' : 'Đã ẩn' }}
                </div>
              </div>
            </router-link>

            <!-- Info -->
            <div class="album-card__info">
              <router-link
                  :to="{ path: '/album-v2/detail/' + albumResponse.albumIdx }"
                  class="album-card__name-link"
              >
                <div class="album-card__name" :title="albumResponseAlbumName(albumResponse)">
                  {{ albumResponseAlbumName(albumResponse) }}
                </div>
              </router-link>

              <div class="album-card__meta">
                <span
                    class="album-card__meta-item"
                    v-if="albumResponse.className"
                >
                  <i class="el-icon-office-building"/> {{ albumResponse.className }}
                </span>
                <span class="album-card__meta-item" v-if="albumResponse.albumType">
                  <i class="el-icon-collection-tag"/> {{ albumTypeLabel(albumResponse.albumType) }}
                </span>
              </div>

              <div class="album-card__footer">
                <el-checkbox
                    v-model="albumResponse.checkApprove"
                    :key="albumResponse.albumIdx"
                    @change="(val) => checkApproveAlbum(albumResponse.albumIdx, val)"
                :aria-label="'Chọn album ' + albumResponse.albumName">Chọn</el-checkbox>
                <span class="album-card__date">{{ albumResponse.createdDate | formatDateTime }}</span>
              </div>

              <!-- Action bar -->
              <div
                  class="album-card__actions"
                  :class="albumResponse.albumView ? 'actions--visible' : 'actions--hidden'"
              >
                <el-button
                    size="mini"
                    :loading="albumResponse.checkDownload"
                    @click="download1(albumResponse)"
                    class="album-card__action-btn album-card__action-btn--download"
                    icon="el-icon-download"
                >Tải về</el-button>

                <!-- Tạm ẩn duyệt/hủy duyệt tại từng item; thao tác hàng loạt vẫn dùng ở menu Tác vụ. -->
                <!--
                <el-button
                    v-if="checkPermission(['studentQuality_ablum_update'])"
                    size="mini"
                    @click="updateAlbumApproval(albumResponse)"
                    class="album-card__action-btn album-card__action-btn--approval"
                    :icon="albumResponse.albumApproved ? 'el-icon-close' : 'el-icon-check'"
                >{{ albumResponse.albumApproved ? 'Hủy duyệt' : 'Duyệt' }}</el-button>
                -->

                <el-button
                    v-if="checkPermission(['studentQuality_ablum_update'])"
                    size="mini"
                    @click="deleteAlbum(albumResponse.albumIdx)"
                    class="album-card__action-btn album-card__action-btn--danger"
                    icon="el-icon-delete"
                >Xóa</el-button>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>

    <!-- ── Empty state ─────────────────────────────────────────────────────── -->
    <div v-else class="empty-state">
      <i class="el-icon-folder-opened empty-state__icon"/>
      <div class="empty-state__title">{{ hasAlbumFilters ? 'Không tìm thấy album phù hợp' : 'Chưa có album nào' }}</div>
      <div class="empty-state__desc">{{ hasAlbumFilters ? 'Thử thay đổi bộ lọc để xem các album khác.' : 'Tạo album mới để bắt đầu lưu trữ hình ảnh của trường.' }}</div>
      <router-link
          v-if="checkPermission(['studentQuality_ablum_update'])"
          :to="{ path: '/album-v2/add' }"
          class="cancel-link"
      >
          <Phase2ActionButton type="success" icon="el-icon-plus" class="btn-action">
          Tạo Album
        </Phase2ActionButton>
      </router-link>
    </div>

    <!-- ── Pagination ──────────────────────────────────────────────────────── -->
    <div v-if="!listLoading && !listError && total > 0" class="pagination-wrap">
      <el-pagination
          background
          @size-change="handleSizeChange"
          :current-page="pageNumber"
          :page-size="maxPageItem"
          @current-change="handleCurrentChange"
          :page-sizes="listPageSize"
          :layout="$pageLayoutDefault"
          :total="total"
      />
    </div>

    <AlbumDownloadProgressDialog
        :visible="showDownloadProgress"
        indeterminate
        :percentage="downloadProgress"
        :title="downloadProgressTitle"
        :message="downloadProgressMessage"
    />

  </div>
</template>

<script>
import "./styles/album-studio.scss";
import checkPermission from "@/utils/permission.js";
import AlbumService from "./services/AlbumService";
import AlbumImageUrlService from "./services/AlbumImageUrlService";
import {
  ALBUM_TYPE_CLASS,
  ALBUM_TYPE_OPTIONS,
  ALBUM_TYPE_SCHOOL,
  getAlbumTypeLabel,
} from "./constants/AlbumConstant";
import {mapState} from "vuex";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import {albumApprovalFeedback} from "./services/AlbumApprovalResult";
import TagFlag from "@/views/tag/TagFlag.vue";
import Phase2ActionButton from "@/components/common/phase2/Phase2ActionButton.vue";
import Phase2Dropdown from "@/components/common/phase2/Phase2Dropdown.vue";
import AlbumDownloadProgressDialog from "./components/AlbumDownloadProgressDialog.vue";

export default {
  components: {
    TagFlag,
    Phase2ActionButton,
    Phase2Dropdown,
    AlbumDownloadProgressDialog,
  },
  beforeCreate() {
    this._albumImageLoader = {
      queue: [],
      running: false,
      searchId: 0,
      destroyed: false,
    };
  },
  data() {
    return {
      listPageSize: [30, 60, 100],
      currentPagePagination: 1,
      pageTotal: this.$pageTotalDefault,
      maxPageItem: 30,
      pageNumber: 1,
      layout: "sizes, prev, pager, next",
      total: 0,
      listLoading: true,
      listError: false,
      pageSize: 12,
      currentPageNumber: 1,
      showProgress: false,
      showDownloadProgress: false,
      downloadProgress: 0,
      downloadProgressTitle: "Đang chuẩn bị tải album",
      downloadProgressMessage: "Đang tạo liên kết tải xuống...",
      checkApprove: false,
      listIdApproveAlbum: [],
      pageList: [3, 6, 8, 10],
      multipleSelectionEmployee: [],
      showCreateDialog: false,
      showUpdateDialog: false,
      employeeData: [],
      statusEmployee: [],
      departmentList: [],
      idList: [],
      albumResponseList: [],
      albumTypesOption: [...ALBUM_TYPE_OPTIONS],
      albumTypeClass: ALBUM_TYPE_CLASS,
      statusAlbum: [
        {label: "Đã ẩn", value: false},
        {label: "Đang hiện", value: true},
      ],
      dataSearch: {
        // Empty means all album types. Teachers are narrowed to CLASS in created().
        albumType: "",
        idClass: "",
        approved: "",
        // Do not hide existing albums with a missing/legacy createdDate on first load.
        // Element UI expects null/[] for an empty daterange. Keep it empty
        // until the user chooses dates so the initial request is unfiltered.
        dateList: null,
      },
      isCheckAll: false,
      isIndeterminate: false,
      batchActionLoading: false,
      taskActions: [
        { command: "approveAlbum", label: "Duyệt Album", icon: "el-icon-check" },
        { command: "unApproveAlbum", label: "Hủy duyệt Album", icon: "el-icon-close" },
        { command: "deleteMultiAlbum", label: "Xóa Album", icon: "el-icon-delete", danger: true, divided: true }
      ],
    };
  },
  computed: {
    hasAlbumFilters() {
      return Boolean(this.dataSearch.idClass || this.dataSearch.albumType
          || typeof this.dataSearch.approved === "boolean"
          || (this.dataSearch.dateList && this.dataSearch.dateList.length));
    },
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),

    listClass() {
      if (this.getAppTypeUserLogin === "plus") return this.classListCommon;
      if (this.getAppTypeUserLogin === "teacher") return this.classInTeacher;
      return [];
    },

    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  created() {
    if (this.getAppTypeUserLogin === "plus") {
      this.$store.dispatch("classStore/fetchDataClassListCommon");
    } else if (this.getAppTypeUserLogin === "teacher") {
      this.dataSearch.albumType = ALBUM_TYPE_CLASS;
      this.$store.dispatch("classStore/fetchDataClassInTeacher");
    }
  },
  watch: {
    listClass: {
      immediate: true,
      handler(newVal) {
        if (this.getAppTypeUserLogin === "teacher" && !this.dataSearch.idClass && newVal.length > 0) {
          const firstClass = newVal.find(item => item.checked) || newVal[0];
          this.dataSearch.idClass = firstClass.id;
          this.searchByProperties();
        }
      },
    },
    listIdApproveAlbum(newVal) {
      if (newVal.length === 0) {
        this.isCheckAll = false;
        this.isIndeterminate = false;
      } else if (newVal.length > 0 && newVal.length < this.albumResponseList.length) {
        this.isCheckAll = false;
        this.isIndeterminate = true;
      } else if (newVal.length > 0 && newVal.length === this.albumResponseList.length) {
        this.isCheckAll = true;
        this.isIndeterminate = false;
      }
    }
  },
  methods: {
    handleCheckAllChange(val) {
      const data = this.albumResponseList;
      data.forEach((item) => {
        item.checkApprove = val;
        this.checkApproveAlbum(item.albumIdx, val);
      });
    },
    checkPermission,
    albumTypeLabel: getAlbumTypeLabel,
    tableHeaderColor() {
      return "background-color: var(--primary);color: #fff;font-weight: bold";
    },
    tableRowStyle({row}) {
      row.id;
    },
    handleSizeChange(maxPageItem) {
      this.maxPageItem = maxPageItem;
      this.pageNumber = 1;
      this.currentPagePagination = 1;
      this.searchByProperties();
    },
    handleCurrentChange(pageNumber) {
      this.currentPagePagination = pageNumber;
      this.pageNumber = pageNumber;
      this.searchByProperties();
    },
    handleCommandAction(command) {
      switch (command) {
        case "approveAlbum":
          this.updateMultiAlbumApproval(true);
          break;
        case "unApproveAlbum":
          this.updateMultiAlbumApproval(false);
          break;
        case "deleteMultiAlbum":
          this.deleteMultiAlbum();
          break;
      }
    },

    handleSelectionChange(val) {
      this.multipleSelectionEmployee = val;
    },
    handleEdit(index, row) {
      this.showUpdateDialog = true;
      console.log(row);
    },
    handleDelete(index, row) {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa nhân viên đã chọn?",
          "Thông báo!"
      );
      console.log(row);
    },
    createEmployeeDialog() {
      this.showCreateDialog = true;
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
      this.searchByProperties();
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
      this.searchByProperties();
    },
    searchHeaderMethod() {
      this.pageNumber = 1;
      this.currentPagePagination = 1;
      this.searchByProperties();
    },
    handleAlbumTypeChange() {
      if (this.dataSearch.albumType !== ALBUM_TYPE_CLASS) {
        this.dataSearch.idClass = "";
      }
      this.searchHeaderMethod();
    },
    async searchByProperties() {
      const searchId = this.cancelPendingAlbumImages();
      this.listIdApproveAlbum = [];
      this.listLoading = true;
      this.listError = false;
      const dateList = Array.isArray(this.dataSearch.dateList)
          ? this.dataSearch.dateList
          : [];
      const selectedType = [ALBUM_TYPE_SCHOOL, ALBUM_TYPE_CLASS].includes(this.dataSearch.albumType)
          ? this.dataSearch.albumType
          : null;
      try {
        const resp = await AlbumService.getAlbumsBySchoolV2(
            this.pageNumber,
            this.maxPageItem,
            {
              startDate: dateList[0] || "",
              endDate: dateList[1] || "",
              type: selectedType,
              classId: this.dataSearch.idClass,
              approved: this.dataSearch.approved,
            });
        if (!this.isAlbumImageSearchCurrent(searchId)) return;
        const envelope = resp.data || {};
        const payload = envelope.data != null ? envelope.data : envelope;
        const responseList = this.extractAlbumList(payload);
        this.albumResponseList = responseList.map((item) => this.normalizeAlbumCard(item, searchId));
        const envelopeTotal = Number(envelope.total);
        const payloadTotal = this.extractTotal(payload, responseList.length);
        this.total = Number.isFinite(envelopeTotal) &&
        (envelopeTotal > 0 || payloadTotal === 0)
            ? envelopeTotal
            : payloadTotal;
        this.resetCheckAll();
        this.albumResponseList.forEach((album) => {
          if (AlbumImageUrlService.needsPresignedUrl(album) || album.urlPictureFirst) {
            this.queueAlbumImage(album);
          }
        });
      } catch (err) {
        if (!this.isAlbumImageSearchCurrent(searchId)) return;
        this.total = 0;
        this.albumResponseList = [];
        this.listError = true;
        console.log(err);
      } finally {
        if (this.isAlbumImageSearchCurrent(searchId)) this.listLoading = false;
      }
    },
    extractAlbumList(payload) {
      if (Array.isArray(payload)) return payload;
      if (!payload || typeof payload !== "object") return [];
      const nested = payload.data && typeof payload.data === "object" ? payload.data : {};
      const list = payload.items || payload.responseList || payload.content || payload.albums || payload.list ||
          nested.items || nested.responseList || nested.content || nested.albums || nested.list ||
          (Array.isArray(payload.data) ? payload.data : []);
      return Array.isArray(list) ? list : [];
    },
    extractTotal(payload, fallback) {
      if (!payload || typeof payload !== "object") return fallback;
      return Number(payload.total ?? payload.totalElements ?? payload.totalItems ?? fallback);
    },
    normalizeAlbumCard(item, searchId) {
      const cover = item.representativePicture || {};
      const storageStatus = cover.storageStatus || "";
      const urlMinio = cover.urlMinio || "";
      const imageNeedsPresign = AlbumImageUrlService.needsPresignedUrl({storageStatus, urlMinio});
      const imageUrl = imageNeedsPresign ? null : (cover.urlPictureShow || null);
      const classNames = Array.isArray(item.classNames) ? item.classNames : [];
      return {
        id: item.idx,
        albumIdx: String(item.idx),
        albumName: item.name || "Album không tên",
        urlPictureFirst: imageUrl,
        urlShowPicture: null,
        urlMinio,
        storageStatus,
        imageLoading: imageNeedsPresign || Boolean(imageUrl),
        imageError: false,
        imageSearchId: searchId,
        pictureNumber: item.count ?? 0,
        classNames,
        className: classNames.join(", "),
        albumType: item.type,
        albumApproved: Boolean(item.approved),
        albumView: true,
        createdDate: item.createdDate,
        checkApprove: false,
        checkDownload: false,
      };
    },
    isAlbumImageSearchCurrent(searchId) {
      const loader = this._albumImageLoader;
      return !loader.destroyed && loader.searchId === searchId;
    },
    cancelPendingAlbumImages() {
      const loader = this._albumImageLoader;
      loader.searchId += 1;
      loader.queue.length = 0;
      return loader.searchId;
    },
    queueAlbumImage(album, force = false) {
      if (!this.isAlbumImageSearchCurrent(album.imageSearchId)) return;
      const cachedUrl = force ? "" : AlbumImageUrlService.getCachedUrl(album);
      if (cachedUrl) {
        this.resolveAlbumImage(album, false, cachedUrl);
        return;
      }
      this._albumImageLoader.queue.push({album, force});
      this.processAlbumImageQueue();
    },
    async processAlbumImageQueue() {
      const loader = this._albumImageLoader;
      if (loader.running) return;
      loader.running = true;
      try {
        while (!loader.destroyed && loader.queue.length > 0) {
          const task = loader.queue.shift();
          if (!this.isAlbumImageSearchCurrent(task.album.imageSearchId)) continue;
          const cachedUrl = task.force ? "" : AlbumImageUrlService.getCachedUrl(task.album);
          await this.resolveAlbumImage(task.album, task.force, cachedUrl);
          // Publish the URL before resolving the next image; no fixed delay.
          await this.$nextTick();
        }
      } finally {
        loader.running = false;
      }
    },
    async resolveAlbumImage(album, force = false, cachedUrl = "") {
      const searchId = album.imageSearchId;
      if (!this.isAlbumImageSearchCurrent(searchId)) return;
      this.$set(album, "imageLoading", true);
      try {
        if (force) AlbumImageUrlService.invalidate(album);
        const url = cachedUrl || (AlbumImageUrlService.needsPresignedUrl(album)
            ? await AlbumImageUrlService.resolve(album, {force})
            : album.urlPictureFirst);
        if (!this.isAlbumImageSearchCurrent(searchId)) return;
        this.$set(album, "urlPictureFirst", url || null);
        this.$set(album, "urlShowPicture", url || null);
        this.$set(album, "imageError", !url);
      } catch (error) {
        if (!this.isAlbumImageSearchCurrent(searchId)) return;
        this.$set(album, "imageError", true);
        console.error("Album image URL error:", error);
      } finally {
        if (this.isAlbumImageSearchCurrent(searchId)) {
          this.$set(album, "imageLoading", false);
        }
      }
    },
    handleAlbumImageError(album) {
      if (!this.isAlbumImageSearchCurrent(album.imageSearchId)) return;
      if (!AlbumImageUrlService.needsPresignedUrl(album) || album.imageRefreshAttempted) {
        this.$set(album, "imageError", true);
        return;
      }
      this.$set(album, "imageRefreshAttempted", true);
      this.$set(album, "imageLoading", true);
      this.$set(album, "imageError", true);
      this.queueAlbumImage(album, true);
    },
    async download1(album) {
      this.$set(album, "checkDownload", true);
      this.showDownloadProgress = true;
      this.downloadProgressTitle = "Đang chuẩn bị tải album";
      this.downloadProgressMessage = "Đang tạo file ZIP và liên kết tải xuống...";
      try {
        const response = await AlbumService.downloadAlbumV2(album.albumIdx);
        this.downloadProgressTitle = "Đang bắt đầu tải album";
        this.downloadProgressMessage = "Đã tạo file ZIP, trình duyệt đang bắt đầu tải xuống...";
        const envelope = response.data || {};
        const payload = envelope.data != null ? envelope.data : envelope;
        const downloadUrl = typeof payload === "string"
            ? payload
            : payload.downloadUrl || payload.url;
        if (!downloadUrl) {
          throw new Error("API không trả về URL tải album");
        }
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = (payload && payload.fileName) || `album-${album.albumIdx}.zip`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.downloadProgressTitle = "Đã bắt đầu tải album";
        this.downloadProgressMessage = "File ZIP đang được tải xuống trên trình duyệt.";
        NotifyMessage.leftCornerNotificationSuccess("Đã bắt đầu tải album. Theo dõi tiến trình trong trình duyệt.");
      } catch (error) {
        console.error("Album V2 download error:", error);
        NotifyMessage.leftCornerNotificationError("Tải album thất bại");
      } finally {
        this.showDownloadProgress = false;
        this.downloadProgress = 0;
        this.$set(album, "checkDownload", false);
      }
    },
    deleteAlbum(id) {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa Album ảnh đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(async () => {
        try {
          await AlbumService.deleteAlbumV2(id);
          NotifyMessage.leftCornerNotificationSuccess("Xóa album thành công!");
          await this.searchByProperties();
          this.$store.dispatch("notificationNavbarStore/fetchNotification");
        } catch (err) {
          console.log(err);
          NotifyMessage.leftCornerNotificationError("Xóa album thất bại");
        }
      });
    },
    deleteMultiAlbum() {
      const albumIdxs = this.getSelectedAlbumIdxs();
      if (albumIdxs.length === 0) {
        NotifyMessage.leftCornerNotificationError("Bạn chưa chọn Album nào");
        return;
      }

      this.$confirm(
          `Bạn có chắc chắn muốn xóa ${albumIdxs.length} Album ảnh đã chọn?`,
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          },
      ).then(() => this.executeBatchAlbumAction("delete", null, albumIdxs))
          .catch(() => {});
    },

    checkApproveAlbum(id, boolean) {
      id = String(id);
      let indexOf = this.listIdApproveAlbum.indexOf(id);
      if (boolean) {
        if (indexOf === -1) {
          this.listIdApproveAlbum.push(id);
        }
      } else {
        if (indexOf !== -1) {
          this.listIdApproveAlbum.splice(indexOf, 1);
        }
      }
    },

    async updateMultiAlbumApproval(approved) {
      const albumIdxs = this.getSelectedAlbumIdxs();
      if (albumIdxs.length === 0) {
        NotifyMessage.leftCornerNotificationError("Chưa có Album nào được chọn!");
        return;
      }
      await this.executeBatchAlbumAction("approval", approved, albumIdxs);
    },

    getSelectedAlbumIdxs() {
      return [...new Set(
          this.listIdApproveAlbum
              .filter((albumIdx) => albumIdx != null && albumIdx !== "")
              .map((albumIdx) => String(albumIdx)),
      )];
    },

    async executeBatchAlbumAction(action, approved, albumIdxs) {
      if (this.batchActionLoading || albumIdxs.length === 0) return;

      this.batchActionLoading = true;
      try {
        if (action === "delete") {
          await AlbumService.deleteAlbumBatchV2(albumIdxs);
          NotifyMessage.leftCornerNotificationSuccess("Xóa album thành công!");
        } else {
          const response = await AlbumService.updateAlbumApprovalBatchResultV2(albumIdxs, approved);
          const feedback = albumApprovalFeedback(response.data.data, albumIdxs, approved);
          if (feedback.type === "success") {
            NotifyMessage.leftCornerNotificationSuccess(feedback.message);
          } else if (feedback.type === "warning") {
            NotifyMessage.leftCornerNotificationWarning(feedback.message);
          } else {
            NotifyMessage.leftCornerNotificationError(feedback.message);
          }
        }
      } catch (err) {
        console.log(err);
        if (action === "delete") {
          NotifyMessage.leftCornerNotificationError("Xóa album thất bại");
        } else {
          NotifyMessage.leftCornerNotificationError(
              err && err.code === "ALBUM_APPROVAL_INVALID_RESULT"
                  ? err.message
                  : approved ? "Duyệt album thất bại" : "Hủy duyệt album thất bại",
          );
        }
      } finally {
        this.resetCheckAll();
        try {
          await this.searchByProperties();
          await this.$store.dispatch("notificationNavbarStore/fetchNotification");
        } catch (refreshError) {
          NotifyMessage.leftCornerNotificationWarning(
              "Chưa cập nhật được danh sách hoặc bộ đếm Album. Vui lòng làm mới để kiểm tra.",
          );
        } finally {
          this.batchActionLoading = false;
        }
      }
    },

    updateAlbumApproval(album) {
      const approved = !album.albumApproved;
      return this.$confirm(
          approved ? "Bạn có chắc chắn muốn duyệt album đã chọn?" : "Bạn có chắc chắn muốn hủy duyệt album đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          },
      ).then(() => this.executeBatchAlbumAction("approval", approved, [String(album.albumIdx)]))
          .catch(() => {});
    },
    albumResponseAlbumName(albumResponse) {
      const albumName = albumResponse.albumName;
      if (albumResponse.urlPictureFirst != null) {
        return albumName;
      } else {
        return albumName + " - No Picture";
      }
    },

    resetCheckAll() {
      this.albumResponseList.forEach((album) => {
        this.$set(album, "checkApprove", false);
      });
      this.isCheckAll = false;
      this.isIndeterminate = false;
      this.listIdApproveAlbum = [];
    }
  },

  beforeMount() {
    this.searchByProperties();
  },
  beforeDestroy() {
    this._albumImageLoader.destroyed = true;
    this.cancelPendingAlbumImages();
  },
};
</script>
